import { useState } from "react";
import { Play } from "lucide-react";
import { useLang } from "@/i18n";

const VIDEO_ID = "0EZpAlMRyG0";
const THUMB = `https://i.ytimg.com/vi/${VIDEO_ID}/hqdefault.jpg`;

export default function VideoBanner() {
    const [playing, setPlaying] = useState(false);
    const { t } = useLang();

    return (
        <section className="bg-white py-2" data-testid="video-banner">
            <div className="relative w-full overflow-hidden bg-ink" style={{ aspectRatio: "16 / 9" }}>
                {playing ? (
                    <iframe
                        src={`https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1&loop=1&playlist=${VIDEO_ID}&modestbranding=1&playsinline=1&rel=0`}
                        title="Azmthullah Packers and Movers Rayachoti — video"
                        className="absolute inset-0 h-full w-full"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                ) : (
                    <button
                        type="button"
                        onClick={() => setPlaying(true)}
                        data-testid="video-banner-play-button"
                        aria-label={t.app.playVideo}
                        className="group absolute inset-0 h-full w-full"
                    >
                        <img
                            src={THUMB}
                            alt="Azmthullah Packers and Movers Rayachoti video"
                            loading="lazy"
                            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                        />
                        <span className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-ink/30 transition-colors group-hover:bg-ink/20">
                            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-white/95 shadow-xl transition-transform group-hover:scale-110 sm:h-20 sm:w-20">
                                <Play className="ms-1 h-7 w-7 fill-ink text-ink sm:h-9 sm:w-9" />
                            </span>
                            <span className="rounded-full bg-white/95 px-4 py-1.5 text-xs font-bold text-ink shadow-md sm:text-sm">
                                {t.app.playVideo}
                            </span>
                        </span>
                    </button>
                )}
                <div className="pointer-events-none absolute inset-x-0 bottom-0 flex justify-start bg-gradient-to-t from-ink/70 to-transparent p-4">
                    <p className="text-xs font-semibold text-white sm:text-sm">
                        Azmthullah Packers &amp; Movers — Rayachoti
                    </p>
                </div>
            </div>
        </section>
    );
}
